import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { IData } from '../../interfaces/data.interface';
import constants from 'src/config/constants';

@Component({
  selector: 'custom-base',
  templateUrl: './custom-base.component.html',
  styleUrls: ['./custom-base.component.css']
})
export class CustomBaseComponent implements OnInit   {
  constructor(
    private readonly _dataService: DataService
  ){}
  data: IData[]  = [];
  whatsAppNumber: string = '';
  whatsAppMessage: string = '';
  isDataReady: boolean = false;
  whatsappUrl: string = '';

  ngOnInit(): void {
    if(localStorage.getItem('whatsAppNumber') && localStorage.getItem('whatsAppMessage')){
      this.whatsAppNumber = localStorage.getItem('whatsAppNumber')!
      this.whatsAppMessage = localStorage.getItem('whatsAppMessage')!;
      this.whatsappUrl = `${constants.whatsappLink}/+${this.whatsAppNumber}?text=${this.whatsAppMessage}`;

    } else {
      this._dataService.getDataWhatsApp().subscribe({
        next: (response)=> {
          this.whatsAppNumber = response.data.find((item: any) => item.typeDataName === constants.WHATSAPP)?.dataValue!;
          this.whatsAppMessage = response.data.find((item: any) => item.typeDataName === constants.WHATSAPP_MESSAGE)?.dataValue!;
          localStorage.setItem('whatsAppNumber', this.whatsAppNumber);
          localStorage.setItem('whatsAppMessage', this.whatsAppMessage);
          this.whatsappUrl = `${constants.whatsappLink}/+${this.whatsAppNumber}?text=${this.whatsAppMessage}`;

      },
        error: (error)=> {
          console.debug(error)
          throw error;
        }
      })
    }
    this.isDataReady = true;
  }
}
